// extracted by mini-css-extract-plugin
export var logo = "freshers2022-module--logo--3GoS3";
export var gamejamTopOverride = "freshers2022-module--gamejamTopOverride--mUdoo";
export var gamejamMapOverride = "freshers2022-module--gamejamMapOverride--3KGCP";